export enum EOutsideContent {
  CONTACT_ONLY = 'contact-only',
  ALWAYS_DISPLAY = 'always-display',
  NEVER_DISPLAY = 'never-display'
}

export enum EComposerNewLineSetting {
  DEFAULT = 'default',
  BLOCK = 'block',
  LINE_BREAK = 'linebreak',
  INVERT = 'invert'
}

export enum EComposerToolbarLocationSetting {
  TOP = 'top',
  BOTTOM = 'bottom'
}

export enum EContactOrdering {
  NAME = 'name',
  USED_AT = 'used-at'
}

export enum EFolderListSize {
  DEFAULT = 'default',
  COMFORTABLE = 'comfortable',
  COMPACT = 'compact'
}
